// extracted by mini-css-extract-plugin
module.exports = {"buttons":"booleanButtons_buttons__XMGl8","not":"booleanButtons_not__2uMT7"};